import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { ProfileTile } from '@/components';
import { SearchResultSection } from '@/pages/search/searchResultSection';
import { getCompatibilityProfilePath } from '@/routes/getCompatibilityPaths';
import { SearchResult } from '@/shared/searchTracking';
import { useCurrentCompatibility } from '@/stores/compatibility';
import { ProfileListItemInterface } from '@/types';

const ProfileSearchResultPure: FC<{
  profileList: ProfileListItemInterface[];
  handleClick: (clickLink, resultType, clickDepth: number) => void;
}> = (props) => {
  const { profileList, handleClick } = props;
  const compatibility = useCurrentCompatibility();

  const onProfileClick = (
    clickItem: ProfileListItemInterface,
    resultDepth: number,
  ) => {
    if (handleClick) {
      const defaultProfilePath = getCompatibilityProfilePath(
        compatibility.slug,
        clickItem.vanityUrl || clickItem._id,
      );
      const profilePath = clickItem.path || defaultProfilePath;
      handleClick(profilePath, SearchResult.PROFILE, resultDepth + 1);
    }
  };

  return (
    <SearchResultSection title="Apps, integrations, and extensions" isH1>
      {profileList.map((item, index) => (
        <ProfileTile
          app={item}
          key={item._id}
          handleClick={() => onProfileClick(item, index)}
        />
      ))}
    </SearchResultSection>
  );
};

export const ProfileSearchResult = observer(ProfileSearchResultPure);
